/* =============================================================
   Loon'r — Spare-liner checkout-intent popup
   -------------------------------------------------------------
   Pairs with snippets/loonr-spare-liner-popup.liquid. When a shopper with
   2+ boots clicks Checkout (drawer #cart-sidebar-checkout OR /cart
   #cart-checkout), we intercept once, offer a size-matched spare liner at
   50% off (one per liner-eligible boot), then let them continue.

   The 50% is applied by a native automatic Buy-2-boots/Get-liners discount,
   server-side — this file only ADDS the size-matched liner variant(s). It
   never touches pricing.

   Liner-eligible = Hi Flyer + Lo Rider. Sidekick counts toward the "2 boots"
   trigger but never gets a spare row (no removable liner).

   SAFETY: checkout must never be blocked by this code. We intercept in the
   CAPTURE phase, but only preventDefault when the cart is cleanly eligible and
   the modal actually opens. Any thrown error, missing data, or unknown state
   falls through and the native checkout proceeds untouched. The "shown once"
   guard is in-memory only (house rule: no local/session storage) and resets
   on reload.
   ============================================================= */
(function () {
  "use strict";

  if (window.__loonrSparePopupBound) return;
  window.__loonrSparePopupBound = true;

  var CFG = null;         // parsed #loonr-spare-data
  var VARIDX = {};        // "Model||Size" -> {id,price,inv,avail}
  var VARSIZES = {};      // Model -> [orderable sizes]
  var cart = null;        // cached /cart.js
  var shown = false;      // shown this pageview
  var pendingCheckoutURL = null;
  var lastFocus = null;
  var trapRelease = null; // shared focus-trap release (loonr-dialog.js)
  var currentOffers = [];  // candidates for the open modal (one spare picked from these)

  function root(path) {
    var r = (window.routes && window.routes.root) || "";
    if (r === "/") r = "";
    return r + path;
  }

  function money(cents) {
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  // Mike 10/30: the 50% spare is offered only in a size with stock. An empty size keeps the full-price cart card
  // ("Ships late Nov") but no half-off popup; it comes back by itself when the size restocks (C5).
  function orderable(v) {
    return !!v && v.inv > 0;
  }

  function firstOrderable(model) {
    var s = VARSIZES[model] || [];
    return s.length ? s[0] : null;
  }

  // Mike 10/30: a liner size at 0 says "Ships late Nov"; the window comes from snippets/loonr-liner-ship.
  function linerShip() { return (CFG && CFG.linerShip) || "late Nov"; }

  function parseConfig() {
    try {
      var el = document.getElementById("loonr-spare-data");
      if (!el) return null;
      var cfg = JSON.parse(el.textContent);
      (cfg.variants || []).forEach(function (v) {
        VARIDX[v.model + "||" + v.size] = v;
        if (v.inv > 0) {
          (VARSIZES[v.model] = VARSIZES[v.model] || []).push(v.size);
        }
      });
      return cfg;
    } catch (e) {
      return null;
    }
  }

  // A boot line's size. Boots share the liner size taxonomy (e.g. "M9/W10").
  // Prefer an option literally named "Size"; fall back to a size-shaped token,
  // then option1 (which the cart liner-upsell snippet also treats as the size).
  function bootSize(item) {
    var owv = item.options_with_values || [];
    for (var i = 0; i < owv.length; i++) {
      if (/size/i.test(owv[i].name)) return String(owv[i].value);
    }
    var vo = item.variant_options || [];
    var re = /^M\d+(\.\d+)?\/(W\d+|\d+)$/i;
    for (var j = 0; j < vo.length; j++) {
      if (re.test(String(vo[j]))) return String(vo[j]);
    }
    return vo.length ? String(vo[0]) : String(item.variant_title || "");
  }

  // Read cart -> total boots, liners already in cart, and one offer per
  // distinct liner-eligible (model,size), each resolved to an orderable variant.
  function analyze(c) {
    var out = { totalBoots: 0, liners: 0, offers: [] };
    if (!c || !CFG) return out;
    var groups = {};
    (c.items || []).forEach(function (it) {
      var pid = String(it.product_id);
      if (CFG.boots[pid]) out.totalBoots += it.quantity;
      if (pid === String(CFG.linerProductId)) out.liners += it.quantity;
      var model = CFG.linerBoots[pid];
      if (model) {
        var size = bootSize(it);
        var key = model + "||" + size;
        if (!groups[key]) groups[key] = { model: model, size: size, boots: 0 };
        groups[key].boots += it.quantity;
      }
    });
    Object.keys(groups).forEach(function (k) {
      var g = groups[k];
      var size = g.size;
      var v = VARIDX[g.model + "||" + size];
      // Only the exact size-matched liner (Codex review 10/11): no fallback to another size,
      // or a customer could buy a liner that doesn't fit. No exact match = no offer.
      if (orderable(v)) out.offers.push({ model: g.model, size: size, boots: g.boots, variant: v });
    });
    return out;
  }

  // Eligible = 2+ boots, at least one size-matched spare available, and no liner
  // already in the cart. The offer is ONE spare per order (the discount is
  // Buy-2-boots / Get-1-liner-at-50%), so once a liner is in the cart we stop.
  function eligible(c) {
    var a = analyze(c);
    if (a.totalBoots < 2) return null;
    if (!a.offers.length) return null;
    if (a.liners >= 1) return null;
    return a;
  }

  function refreshCart(cb) {
    if (window.Shopify && typeof window.Shopify.getCart === "function") {
      window.Shopify.getCart(function (c) { cart = c; if (cb) cb(c); });
    } else {
      fetch(root("/cart.js"), { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; if (cb) cb(c); })
        .catch(function () {});
    }
  }

  /* ---------- modal ---------- */

  // One spare per order: render a single row. If the cart has more than one
  // liner-eligible boot (e.g. a Hi Flyer AND a Lo Rider), let the shopper pick
  // which boot their one spare matches; with a single candidate, show it as text.
  function spareRowHTML(offers) {
    var picker;
    if (offers.length > 1) {
      picker = '<select class="lsp__sel" data-lsp-pick aria-label="Choose which boot your spare liner matches">' +
        offers.map(function (o, i) {
          return '<option value="' + i + '">' + o.model + " · " + o.size + "</option>";
        }).join("") + "</select>";
    } else {
      picker = '<span class="lsp__pick-one">' + offers[0].model + " · " + offers[0].size + "</span>";
    }
    var v = offers[0].variant;
    var pre = v.inv <= 0 && v.avail;
    return (
      '<div class="lsp__row" data-lsp-spare>' +
        '<span class="lsp__th" aria-hidden="true">🥾</span>' +
        '<div class="lsp__b">' +
          '<p class="lsp__t">Your spare liner</p>' +
          picker +
          '<p class="lsp__ship"' + (pre ? "" : " hidden") + '>Ships ' + linerShip() + '.</p>' +
        "</div>" +
        '<span class="lsp__pr"><span class="lsp__was">' + money(v.price) + '</span><span class="lsp__now">' + money(v.price * CFG.discountPct) + "</span></span>" +
      "</div>"
    );
  }

  // The variant for the currently-picked candidate (index into currentOffers).
  function selectedVariant() {
    var pop = document.getElementById("loonr-spare-popup");
    var sel = pop && pop.querySelector("[data-lsp-pick]");
    var idx = sel ? parseInt(sel.value, 10) : 0;
    var o = currentOffers[idx] || currentOffers[0];
    return o ? o.variant : null;
  }

  function syncSparePrice() {
    var v = selectedVariant();
    if (!v) return;
    var pop = document.getElementById("loonr-spare-popup");
    var was = pop.querySelector(".lsp__was");
    var now = pop.querySelector(".lsp__now");
    var ship = pop.querySelector(".lsp__ship");
    if (was) was.textContent = money(v.price);
    if (now) now.textContent = money(v.price * CFG.discountPct);
    if (ship) ship.hidden = !(v.inv <= 0 && v.avail);
  }

  function setMsg(text) {
    var pop = document.getElementById("loonr-spare-popup");
    var m = pop && pop.querySelector("[data-lsp-msg]");
    if (m) { m.textContent = text || ""; m.hidden = !text; }
  }

  function openModal(analysis) {
    var pop = document.getElementById("loonr-spare-popup");
    if (!pop) return false;
    var rows = pop.querySelector("[data-lsp-rows]");
    if (!rows) return false;
    // Highest-value candidate first (Hi Flyer liner > Lo Rider), so the default
    // pick is the pricier spare.
    currentOffers = analysis.offers.slice().sort(function (a, b) { return b.variant.price - a.variant.price; });
    rows.innerHTML = spareRowHTML(currentOffers);
    setMsg("");
    lastFocus = document.activeElement;
    pop.hidden = false;
    pop.setAttribute("aria-hidden", "false");
    pop.classList.add("is-open");
    // Trap Tab inside the popup (shared helper, loonr-dialog.js). This popup
    // intercepts the CHECKOUT click, so an untrapped Tab was walking focus onto
    // the obscured cart behind a purchase-critical dialog. The helper skips
    // `inert` here automatically when the popup renders inside #MainContent.
    if (window.loonrDialog && !trapRelease) trapRelease = window.loonrDialog.trap(pop);
    var modal = pop.querySelector(".lsp__modal");
    if (modal) { try { modal.focus(); } catch (e) {} }
    return true;
  }

  function closeModal() {
    var pop = document.getElementById("loonr-spare-popup");
    if (!pop) return;
    pop.classList.remove("is-open");
    pop.hidden = true;
    pop.setAttribute("aria-hidden", "true");
    if (trapRelease) { trapRelease(); trapRelease = null; }
    if (lastFocus && typeof lastFocus.focus === "function") {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  function goCheckout() {
    if (pendingCheckoutURL) window.location.href = pendingCheckoutURL;
  }

  function addVariant(v) {
    var item = { id: v.id, quantity: 1 };
    if (v.inv <= 0 && v.avail) item.properties = { Ships: linerShip() };
    return fetch(root("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (x) { throw x; });
      return r.json();
    });
  }

  // Add the picked spare, then continue to checkout.
  function addSpare(btn) {
    var v = selectedVariant();
    if (!v) { setMsg("That size just sold out. Try another."); return; }
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = "Adding...";
    addVariant(v)
      .then(function () { refreshCart(); closeModal(); goCheckout(); })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = "Add spare, 50% off";
        setMsg((err && (err.description || err.message)) || "Couldn't add that one. Give it another go?");
      });
  }

  // Delegated handlers on the popup (survives row re-render).
  function wireModal() {
    var pop = document.getElementById("loonr-spare-popup");
    if (!pop) return;

    pop.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-lsp-dismiss]")) { e.preventDefault(); closeModal(); return; }
      if (t.closest("[data-lsp-checkout]")) { e.preventDefault(); closeModal(); goCheckout(); return; }

      var addBtn = t.closest("[data-lsp-addspare]");
      if (addBtn) {
        e.preventDefault();
        addSpare(addBtn);
        return;
      }
    });

    pop.addEventListener("change", function (e) {
      if (e.target.closest("[data-lsp-pick]")) syncSparePrice();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && pop.classList.contains("is-open")) closeModal();
    });
  }

  /* ---------- checkout interception (capture, fail-open) ---------- */

  function checkoutControl(target) {
    if (!target || !target.closest) return null;
    var el = target.closest(".button-checkout, #cart-checkout, #cart-sidebar-checkout");
    if (!el) return null;
    if (el.disabled) return null;
    if (el.classList && el.classList.contains("button-disable")) return null;
    var href = el.getAttribute("href");
    if (href && /^javascript:/i.test(href)) return null;
    return el;
  }

  function checkoutURL(el) {
    var dh = el.getAttribute("data-href");
    if (dh) return dh;
    var oc = el.getAttribute("onclick") || "";
    var m = oc.match(/location\s*=\s*['"]([^'"]+)['"]/);
    if (m) return m[1];
    return root("/checkout");
  }

  document.addEventListener("click", function (e) {
    try {
      if (shown) return;
      var el = checkoutControl(e.target);
      if (!el) return;
      var analysis = eligible(cart);
      if (!analysis) return; // not eligible -> let checkout proceed
      pendingCheckoutURL = checkoutURL(el);
      if (openModal(analysis)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        shown = true;
      }
    } catch (err) {
      /* never block checkout */
    }
  }, true);

  /* ---------- init ---------- */

  CFG = parseConfig();
  if (!CFG) return;
  wireModal();
  refreshCart();
  document.addEventListener("cart-update", function () { refreshCart(); });
})();
